import React from 'react';
import { OrderBumpProvider } from './components/OrderBumpContext';
import { PaymentPopup } from './components/PaymentPopup';
import { UrgencyBanner } from './components/UrgencyBanner';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { CreatorSection } from './components/CreatorSection';
import { ForWhomSection } from './components/ForWhomSection';
import { BusinessSection } from './components/BusinessSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { OrderBumpSection } from './components/OrderBumpSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
export function App() {
  return <OrderBumpProvider data-id="element-0">
      <div className="min-h-screen font-sans text-brand-brown bg-brand-cream selection:bg-brand-gold selection:text-white" data-id="element-1">
        <UrgencyBanner data-id="element-2" />
        <main data-id="element-3">
          <HeroSection data-id="element-4" />
          <PainSection data-id="element-5" />
          <SolutionSection data-id="element-6" />
          <CreatorSection data-id="element-7" />
          <ForWhomSection data-id="element-8" />
          <BusinessSection data-id="element-9" />
          <TestimonialsSection data-id="element-10" />
          <OfferSection data-id="element-11" />
          <OrderBumpSection data-id="element-12" />
          <GuaranteeSection data-id="element-13" />
          <FAQSection data-id="element-14" />
          <FinalCTASection data-id="element-15" />
        </main>
        <PaymentPopup data-id="element-16" />
      </div>
    </OrderBumpProvider>;
}